import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { Grid, TextField, Box, Button } from 'components/ui';
import { WideForm } from 'components/styles_components/form';
import validationSchema from 'validation/place/create';

const Form = ({ onSubmit, onCancel, processing, initialValues }) => {
  const intl = useIntl();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema(intl)}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <WideForm onSubmit={formik.handleSubmit}>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            id="name"
            name="name"
            label={intl.formatMessage({ id: 'name' })}
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.name && Boolean(formik.errors.name)) || undefined}
            helperText={formik.touched.name && formik.errors.name}
          />
          <TextField
            fullWidth
            margin="dense"
            id="street"
            name="street"
            label={intl.formatMessage({ id: 'place.street' })}
            value={formik.values.street}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.street && Boolean(formik.errors.street)) || undefined}
            helperText={formik.touched.street && formik.errors.street}
          />
          <Grid container spacing={2}>
            <Grid size={{ xs: 6, md: 4 }}>
              <TextField
                margin="dense"
                id="zipCode"
                placeholder="XX-XXX"
                name="zipCode"
                label={intl.formatMessage({ id: 'place.zip_code' })}
                value={formik.values.zipCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={(formik.touched.zipCode && Boolean(formik.errors.zipCode)) || undefined}
                helperText={formik.touched.zipCode && formik.errors.zipCode}
              />
            </Grid>
            <Grid size={{ xs: 6, md: 8 }}>
              <TextField
                fullWidth
                margin="dense"
                id="city"
                name="city"
                label={intl.formatMessage({ id: 'place.city' })}
                value={formik.values.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={(formik.touched.city && Boolean(formik.errors.city)) || undefined}
                helperText={formik.touched.city && formik.errors.city}
              />
            </Grid>
          </Grid>
          <TextField
            fullWidth
            margin="dense"
            id="contactPerson"
            name="contactPerson"
            label={intl.formatMessage({ id: 'place.contact.person' })}
            value={formik.values.contactPerson}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              (formik.touched.contactPerson && Boolean(formik.errors.contactPerson)) || undefined
            }
            helperText={formik.touched.contactPerson && formik.errors.contactPerson}
          />
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                margin="dense"
                id="phone"
                name="phone"
                label={intl.formatMessage({ id: 'place.contact.phone' })}
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={(formik.touched.phone && Boolean(formik.errors.phone)) || undefined}
                helperText={formik.touched.phone && formik.errors.phone}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                margin="dense"
                id="email"
                name="email"
                type="email"
                label={intl.formatMessage({ id: 'place.contact.email' })}
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={(formik.touched.email && Boolean(formik.errors.email)) || undefined}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
          </Grid>
          <TextField
            fullWidth
            margin="dense"
            multiline
            rows={4}
            id="notes"
            name="notes"
            label={intl.formatMessage({ id: 'place.notes' })}
            value={formik.values.notes}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.notes && Boolean(formik.errors.notes)) || undefined}
            helperText={formik.touched.notes && formik.errors.notes}
          />
          <Button
            className="margin-top-10"
            fullWidth
            disabled={!formik.isValid || processing || !formik.dirty}
            color="primary"
            variant="contained"
            type="submit"
          >
            <FormattedMessage id="button.save" />
          </Button>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="text" size="small" disabled={processing} onClick={onCancel}>
              <FormattedMessage id="button.cancel" />
            </Button>
          </Box>
        </WideForm>
      )}
    </Formik>
  );
};

export default Form;
